import type { TenantType } from '@bliks-io/contracts';
import { useAuthStore } from '@/stores/auth-store';

/**
 * The real tenant type behind the current session.
 *
 * The session also knows the `super` pseudo-tenant, which has no Tenant
 * document; staff never render a tenant-scoped member form, so it falls back to
 * the customer branch rather than forcing every caller to handle a case it
 * cannot reach.
 */
export function useSessionTenantType(): TenantType {
  const sessionTenantType = useAuthStore((state) => state.tenantType);
  return sessionTenantType && sessionTenantType !== 'super' ? sessionTenantType : 'customer';
}
